<script>
import { layoutComputed } from "@/Template/State/Helpers";

import Vertical from "./vertical";

export default {
    components: {
        Vertical,
    },
    data() {
        return {};
    },
    computed: {
        ...layoutComputed,
    },
    mounted() {
        // document.querySelector("html").setAttribute('dir', 'rtl');
    }
};
</script>

<template>
    <div>
        <Vertical>
            <slot />
        </Vertical>
    </div>
</template>
